import * as pdfjsLib from "pdfjs-dist/build/pdf";
import pdfWorker from "pdfjs-dist/build/pdf.worker.entry";
import imageCompression from "browser-image-compression";

pdfjsLib.GlobalWorkerOptions.workerSrc = pdfWorker;

/**
 * Extract first page of a PDF as an image blob (PNG).
 */
export const getCanvasBlobFromPdf = async (pdfFile) => {
  const arrayBuffer = await pdfFile.arrayBuffer();
  const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
  const page = await pdf.getPage(1);
  const viewport = page.getViewport({ scale: 2 });

  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");
  canvas.width = viewport.width;
  canvas.height = viewport.height;

  await page.render({ canvasContext: context, viewport }).promise;

  return new Promise((resolve) => {
    canvas.toBlob((blob) => resolve(blob), "image/png");
  });
};

/**
 * Generate high- and low-quality thumbnails from an image blob.
 */
export const generateThumbnails = async (imageBlob) => {
  const highQuality = await imageCompression(imageBlob, {
    maxWidthOrHeight: 800,
    initialQuality: 0.8,
    useWebWorker: true,
  });

  const lowQuality = await imageCompression(imageBlob, {
    maxWidthOrHeight: 200,
    initialQuality: 0.5,
    useWebWorker: true,
  });

  return {
    highQuality,
    lowQuality,
  };
};

// export const fetchImageAsBlob = async (imageUrl) => {
//   const response = await fetch(imageUrl);
//   if (!response.ok) throw new Error("Failed to fetch image");
//   const blob = await response.blob();
//   const filename = imageUrl?.path?.split("/").pop()?.split("?")[0] || "image.png";
//   return new File([blob], filename, { type: blob.type });
// };

export const fetchImageAsBlob = async (imageUrl) => {
  const response = await fetch(imageUrl);
  if (!response.ok) throw new Error("Failed to fetch image");
  const blob = await response.blob();
  // Extract filename from signed GCP URL 
  let filename = "image.png";
  try {
    const urlObj = new URL(imageUrl);
    filename = urlObj.pathname.split("/").pop()?.split("?")[0] || "image.png";
  } catch {
    // fallback if imageUrl is not a valid URL
    filename = imageUrl.split("/").pop()?.split("?")[0] || "image.png";
  }
  return new File([blob], filename, { type: blob.type });
};


export const prepareOrderedUploadImages = async (images) => {
  const filesInOrder = await Promise.all(
    images
      .filter(img => img instanceof File || (typeof img?.path === "string" && img.path)) // Skip items with invalid path
      .map(async (img) => {
        if (img instanceof File) return img; // New file, no conversion needed

        if (typeof img?.path !== "string" || !img.path) {
          throw new Error("Invalid image path");
        }

        // Convert existing uploaded image (signed URL) into File
        console.log("Fetching image from path:", img);
        const response = await fetch(img.path);
        const blob = await response.blob();
        const filename = img.path.split("/").pop()?.split("?")[0] || "image.png";

        return new File([blob], filename, { type: blob.type });
      })
  );

  return filesInOrder;
};
